import { gql } from '@urql/core';
import React from 'react';
import { OurEsportsCardFragment } from '../../../generated/spin-graphql';
import { GameIcon } from '../../icons/GameIcon';

type Props = {
    games: OurEsportsCardFragment[];
};

gql`
    fragment OurEsportsCard on espin_college_game {
        game {
            name
            game_definition
        }
    }
`;

export const OurEsportsCard: React.FC<Props> = ({ games }) => {
    return (
        <div className="profile-card dark-theme">
            <div className="title-container">
                <h2 className="title">Our Esports Titles</h2>
                <div className="games">
                    {games.map((game, index: number) => (
                        <div className="game-container" key={`scholarship-link-${index}`}>
                            <GameIcon game={game.game.game_definition} gameName={game.game.name} className="college" />
                            {game.game.name}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
